import { ChartBinSize } from '@frontend/chart/types';

/** Default overview windows when detail URL has no after/before. */
export type InsightDefaultRangeKey = '30d' | '60d' | '6mo' | '2w' | 'none';

/** Entity filters the detail page may expose (Phase 2). */
export type InsightEntityFilterKey = 'spot' | 'product' | 'user' | 'iotType' | 'iotBrand';

export interface InsightFilterConfig {
    /** When false, detail page hides the filter bar for this insight. */
    enabled: boolean;
    /** When false, hide date/bin controls (entity-only insights such as stale lists). */
    showDateRange: boolean;
    defaultRange: InsightDefaultRangeKey;
    /**
     * Bin sizes the user may select. Empty → no bin control (bin locked to defaultBinSize).
     * Still used for guards when the range changes.
     */
    editableBinSizes: ChartBinSize[];
    defaultBinSize: ChartBinSize;
    /**
     * When true, bin cannot be changed (heatmaps / hour-of-day folds).
     * Range is clamped to the max for this bin instead of upgrading.
     */
    lockBinSize: boolean;
    /** Which entity selects to show on the detail filter bar. */
    entityFilters: InsightEntityFilterKey[];
}

export const INSIGHT_FILTER_PARAM = {
    AFTER: 'after',
    BEFORE: 'before',
    BIN_SIZE: 'bin_size',
    SPOT_ID: 'spot_id',
    PRODUCT_ID: 'product_id',
    USER_ID: 'user_id',
    IOT_TYPE: 'type',
    IOT_BRAND: 'brand'
} as const;

export const INSIGHT_ENTITY_FILTER_PARAMS = [
    INSIGHT_FILTER_PARAM.SPOT_ID,
    INSIGHT_FILTER_PARAM.PRODUCT_ID,
    INSIGHT_FILTER_PARAM.USER_ID,
    INSIGHT_FILTER_PARAM.IOT_TYPE,
    INSIGHT_FILTER_PARAM.IOT_BRAND
] as const;
